import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconsModule } from '../../design/icons.module';
import { FiltersToggleComponent } from './filters-collapse.component';
import { FiltersCollapseDirective } from './filters-collapse.directive';

@NgModule({
  declarations: [FiltersToggleComponent, FiltersCollapseDirective],
  imports: [CommonModule, IconsModule],
  exports: [FiltersCollapseDirective]
})
export class FiltersCollapseModule { }
